import {
  faArrowLeft,
  faBars,
  faBuilding,
  faChevronDown,
  faClipboard,
  faHouse,
  faPowerOff,
  faUserPlus,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  InputGroup,
  Modal,
  Navbar,
  Offcanvas,
  Row,
  Tab,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OverlayLoader from "../../components/OverlayLoader";
import Logo from "../../images/tipkitLogo.svg";
import {
  getUserDetails,
  impersonateUserEnd,
  updateUserProfile,
  userLogout,
} from "../../redux/Actions/userAction";
import AddRoles from "./AddRoles";
import AddUser from "./AddUser";
import Airbnb from "./Airbnb/Airbnb";
import Attendants from "./Attendants/Attendants";
import Bellman from "./BellDesk/Bellman";
import ClientProfilePage from "./ClientProfilePage";
import ClientReports from "./ClientReports";
import ClientStats from "./ClientStats";
import Documents from "./QrCodes/Documents";
import Valets from "./Valet/Valets";
import useScreenDimensions from "../../hook/useScreenDimensions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import {
  agreeUserAgreement,
  getUserAgreement,
} from "../../redux/slices/clientSlice";
import { act } from "react";

const Dashboard = () => {
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    canRead: false,
    toDownload: false,
    toAddMaid: false,
    toDeleteMaid: false,
    viewTransactions: false,
    viewAttendants: false,
    viewValets: false,
    viewBellmans: false,
    viewAirbnb: false,
    adminServiceMaids: false,
    adminServiceValets: false,
    adminServiceBellmen: false,
    adminServiceAirbnb: false,
  });
  const { width } = useScreenDimensions();
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [agreement, setAgreement] = useState(null);
  const [activeTab, setActiveTab] = useState("#stats");
  const [collapsed, setCollapsed] = useState(false);
  const [agreementLoading, setAgreementLoading] = useState(false);
  const [agreementDownlaoding, setAgreementDownlaoding] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [show, setShow] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);

  const userInfo = useSelector((state) => state.userDetails);
  const {
    loading: updateLoading,
    success: updateSuccess,
    error: updateError,
  } = useSelector((state) => state.userUpdate);

  const isImpersonating = useSelector(
    (state) => state.userLogin.userInfo.userImpersonating,
  );
  const { loading, error, user } = userInfo;
  const services = user?.services || {};
  console.log("Services from state: ", services);

  const agreementRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // const handleClose = () => {
  //   setShow(false);
  //   setPassword("");
  //   setConfirmPassword("");
  // };

  // const handleShow = () => {
  //   setShow(true);
  //   setName(user.companyName);
  //   setEmail(user.email);
  // };
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
  };
  // const handleSaveChanges = () => {
  //   if (password == confirmPassword && password != "") {
  //     setPasswordMatch(false);
  //     const updatedUser = {
  //       name,
  //       email,
  //       password,
  //     };
  //     dispatch(updateUserProfile(updatedUser));
  //     setShow(false);
  //     setPassword("");
  //     setConfirmPassword("");
  //     // message.success("Password updated");
  //   } else {
  //     setPasswordMatch(true);
  //   }
  // };

  const handleLogout = () => {
    dispatch(userLogout());
    navigation("/login");
  };

  const handleBackToSuperAdmin = () => {
    setScreenLoading(true);
    setTimeout(() => {
      setScreenLoading(!screenLoading);
      dispatch(
        impersonateUserEnd(isImpersonating.id, isImpersonating.email, navigate),
      );
    }, 1000);
  };

  const handleAgree = () => {
    setAgreementLoading(true);
    dispatch(agreeUserAgreement())
      .then(() => {
        setAgreementLoading(false);
        setShowAgreementModal(false);
        message.success("Thank you!");
      })
      .catch(() => {
        setAgreementLoading(false);
        message.error("Something went wrong. Please try again.");
      });
  };

  const handleDownloadPDF = () => {
    setAgreementDownlaoding(true);
    const element = document.getElementById("agreement-pdf");

    const options = {
      margin: 10,
      filename: `${agreement?.title || "ServiceAgreement"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();

    setAgreementDownlaoding(false);
  };

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch, passwordMatch, updateSuccess]);

  useEffect(() => {
    if (
      user &&
      user.serviceAgreement &&
      !user.serviceAgreement.agreed &&
      !isImpersonating
    ) {
      console.log("Showinh agreement modal:", user);
      setShowAgreementModal(true);
      dispatch(getUserAgreement())
        .unwrap()
        .then((data) => {
          setAgreement(data);
        })
        .catch(() => {
          message.error("Failed to fetch service agreement");
        });
    }
  }, [user, isImpersonating, dispatch]);

  useEffect(() => {
    const updatedPermissions = {
      ...permissions,
      isAdmin: user?.isAdmin,
      canRead: user?.roles?.permissions?.read || false,
      toDownload: user?.roles?.permissions?.download || false,
      toAddMaid: user?.roles?.permissions?.addMaid || false,
      toDeleteMaid: user?.roles?.permissions?.deleteMaid || false,
      viewTransactions: user?.isAdmin
        ? true
        : user.roles?.permissions?.viewTransactions || false,
      viewAttendants: user?.isAdmin
        ? user.services?.maids?.enabled
        : user.roles?.permissions?.viewAttendants || false,
      viewValets: user.isAdmin
        ? user?.services?.valets?.enabled
        : user?.roles?.permissions?.viewValets || false,
      viewBellmans: user.isAdmin
        ? user?.services?.bellmen?.enabled
        : user?.roles?.permissions?.viewBellmans || false,
      viewAirbnb: user.isAdmin
        ? user?.services?.airbnb?.enabled
        : user?.roles?.permissions?.viewAirbnb || false,
    };
    setPermissions((prevPermissions) => {
      return JSON.stringify(prevPermissions) !==
        JSON.stringify(updatedPermissions)
        ? updatedPermissions
        : prevPermissions;
    });
    // setPermissions(updatedPermissions);
  }, [permissions, user]);

  return (
    <>
      <div style={{ display: "none" }}>
        <div id="agreement-pdf">
          <h3 className="text-center mb-4">{agreement?.title}</h3>

          {agreement?.content?.recitals && (
            <section className="mb-4">
              <h5 className="fw-bold">Recitals</h5>
              <p>{agreement.content.recitals}</p>
            </section>
          )}

          {agreement?.content?.articles?.map((article, idx) => (
            <section key={idx} className="mb-4">
              <h6 className="fw-bold">{article.title}</h6>
              <p dangerouslySetInnerHTML={{ __html: article.body }} />
            </section>
          ))}

          {agreement?.content?.acceptance && (
            <section className="mt-4">
              <h5 className="fw-bold">Acceptance</h5>
              <p>{agreement.content.acceptance}</p>
            </section>
          )}
        </div>
      </div>

      {screenLoading ? <OverlayLoader /> : null}

      {/* --------------------------------------------- NAVBAR -------------------------------------------------- */}
      {isImpersonating && (
        <div className="py-1 bg-success">
          <Container
            fluid
            className="d-flex justify-content-between align-items-center"
          >
            {/* "Logged in as" label */}
            <span className="text-light fs-7">
              <span> {isImpersonating.name}</span> Logged in as:{" "}
              <strong>
                {user && (user.isAdmin ? user.companyName : user.name)}
              </strong>
            </span>
            <Button
              variant="outline-success text-light border-0"
              size="sm"
              onClick={handleBackToSuperAdmin}
            >
              <FontAwesomeIcon icon={faArrowLeft} className="me-2 text-light" />
              Back to {isImpersonating.name || "dashboard"}
            </Button>
          </Container>
        </div>
      )}
      <Navbar bg="primary" variant="dark" className="py-3">
        <Container fluid className="px-3">
          <Row className="w-100 m-0 align-items-center">
            <Col xs="auto" className="pe-0">
              <Button
                variant="primary"
                className="fs-5 p-2"
                onClick={() => setCollapsed(!collapsed)}
              >
                <FontAwesomeIcon icon={faBars} />
              </Button>
            </Col>
            <Col className="text-center">
              <Navbar.Brand className="mx-auto">
                <img
                  src={Logo}
                  alt="tipkit"
                  width="100"
                  className="d-inline-block align-top"
                />
              </Navbar.Brand>
            </Col>
            <Col xs="auto" className="px-0">
              <Dropdown align={"end"}>
                <span className="text-light me-1">
                  {user && user.isAdmin ? user.companyName : user?.name}
                </span>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-basic"
                  className="custom-dropdown-toggle"
                >
                  <FontAwesomeIcon icon={faChevronDown} className="fs-6" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="px-2">
                  <Button
                    className="w-100 border-0"
                    variant="outline-danger"
                    onClick={handleLogout}
                  >
                    <FontAwesomeIcon icon={faPowerOff} className="me-2" />
                    Logout
                  </Button>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Container>
      </Navbar>
      {/* ------------------------------------- SERVICE AGREEMENT POPUP --------------------------------------- */}
      <Modal
        show={showAgreementModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header>
          <Modal.Title className="mx-auto">{agreement?.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "65vh", overflowY: "auto" }}>
          <div className="px-2" ref={agreementRef}>
            <div className="w-100 text-center d-none">
              <h5 className="mb-3">{agreement?.title}</h5>
            </div>
            {/* Recitals */}
            {agreement?.content?.recitals && (
              <section className="mb-4">
                <h5 className="fw-bold">Recitals</h5>
                <p>{agreement.content.recitals}</p>
              </section>
            )}

            {/* Articles */}
            {agreement?.content?.articles?.map((article, idx) => (
              <section key={idx} className="mb-4">
                <h6 className="fw-bold">{article.title}</h6>
                <p
                  dangerouslySetInnerHTML={{ __html: article.body }}
                  style={{ whiteSpace: "pre-line" }}
                />
              </section>
            ))}

            {/* Acceptance */}
            {agreement?.content?.acceptance && (
              <section className="mt-4">
                <h5 className="fw-bold">Acceptance</h5>
                <p>{agreement.content.acceptance}</p>
              </section>
            )}
          </div>
        </Modal.Body>

        {/* Fixed footer */}
        <Modal.Footer className="justify-content-center">
          <Button
            variant="outline-primary"
            disabled={agreementLoading || !agreement || agreementDownlaoding}
            onClick={() => {
              message.info("Downloading PDF...");
              handleDownloadPDF();
            }}
          >
            Download PDF
          </Button>
          <Button
            disabled={agreementLoading || !agreement}
            variant="primary"
            onClick={handleAgree}
          >
            {agreementLoading ? "Processing..." : "I Agree"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* -------------------------------------------- DASHBOARD TAB -------------------------------------------- */}
      {user && (
        <Tab.Container activeKey={activeTab}>
          <Row className="m-0">
            <Col
              xs={2}
              md={collapsed ? 1 : 2}
              className={`sidebar vh-100 bg-primary sticky-top ${
                collapsed ? "collapsed" : "expanded"
              }`}
            >
              {collapsed ? (
                <Row className="h-100">
                  <Col className="pt-5">
                    <Button
                      variant="primary"
                      className="w-100 text-light my-2 fs-5 p-1"
                      onClick={() => setCollapsed(!collapsed)}
                    >
                      <FontAwesomeIcon icon={faHouse} />
                    </Button>
                    <Button
                      variant="primary"
                      className="w-100 text-light my-2 p-1"
                      onClick={() => setCollapsed(!collapsed)}
                    >
                      <FontAwesomeIcon icon={faUsersGear} size="lg" />
                    </Button>
                    <Button
                      variant="primary"
                      className="w-100 text-light my-2 fs-5 p-1"
                      onClick={() => setCollapsed(!collapsed)}
                    >
                      <FontAwesomeIcon icon={faClipboard} />
                    </Button>
                  </Col>
                </Row>
              ) : (
                <Row className="h-100">
                  <Col className="mt-5 pe-3">
                    <h6 className="text-white bg-primary-dark fw-normal mb-0 p-2 rounded-1 fs-7">
                      <FontAwesomeIcon
                        icon={faHouse}
                        className="me-2 "
                        size="sm"
                      />
                      Home
                    </h6>
                    <div
                      className={`button-wrapper ${
                        activeTab === "#stats" ? "active-tab" : ""
                      }`}
                    >
                      <div className="indicator" />
                      <Button
                        variant={
                          activeTab === "#stats" ? "outline-success" : "primary"
                        }
                        className="w-100 text-start border-0 fs-7"
                        onClick={() => handleTabChange("#stats")}
                      >
                        Overview
                      </Button>
                    </div>

                    <div
                      className={`button-wrapper ${
                        activeTab === "#profile" ? "active-tab" : ""
                      }`}
                    >
                      <div className="indicator" />
                      <Button
                        variant={
                          activeTab === "#profile"
                            ? "outline-success"
                            : "primary"
                        }
                        className="w-100 text-start border-0 fs-7"
                        onClick={() => handleTabChange("#profile")}
                      >
                        Profile
                      </Button>
                    </div>
                    <h6 className="text-white bg-primary-dark fw-normal mb-0 mt-2 p-2 rounded-1 fs-7">
                      <FontAwesomeIcon
                        icon={faBuilding}
                        className="me-2"
                        size="sm"
                      />
                      Services
                    </h6>
                    {permissions.viewAttendants && (
                      <div
                        className={`button-wrapper ${
                          activeTab === "#attendants" ? "active-tab" : ""
                        }`}
                      >
                        <div className="indicator" />
                        <Button
                          variant={
                            activeTab === "#attendants"
                              ? "outline-success"
                              : "primary"
                          }
                          className="w-100 text-start border-0 fs-7"
                          onClick={() => handleTabChange("#attendants")}
                        >
                          Attendants
                        </Button>
                      </div>
                    )}
                    {permissions.viewValets && (
                      <div
                        className={`button-wrapper ${
                          activeTab === "#valet" ? "active-tab" : ""
                        }`}
                      >
                        <div className="indicator" />
                        <Button
                          variant={
                            activeTab === "#valet"
                              ? "outline-success"
                              : "primary"
                          }
                          className="w-100 text-start border-0 fs-7"
                          onClick={() => handleTabChange("#valet")}
                        >
                          Valets
                        </Button>
                      </div>
                    )}
                    {permissions.viewBellmans && (
                      <div
                        className={`button-wrapper ${
                          activeTab === "#bellman" ? "active-tab" : ""
                        }`}
                      >
                        <div className="indicator" />
                        <Button
                          variant={
                            activeTab === "#bellman"
                              ? "outline-success"
                              : "primary"
                          }
                          className="w-100 text-start border-0 fs-7"
                          onClick={() => handleTabChange("#bellman")}
                        >
                          Bell Desk
                        </Button>
                      </div>
                    )}
                    {permissions.viewAirbnb && (
                      <div
                        className={`button-wrapper ${
                          activeTab === "#airbnb" ? "active-tab" : ""
                        }`}
                      >
                        <div className="indicator" />
                        <Button
                          variant={
                            activeTab === "#airbnb"
                              ? "outline-success"
                              : "primary"
                          }
                          className="w-100 text-start border-0 fs-7"
                          onClick={() => handleTabChange("#airbnb")}
                        >
                          Airbnb
                        </Button>
                      </div>
                    )}
                    {permissions.isAdmin && (
                      <>
                        <h6 className="text-white bg-primary-dark fw-normal p-2 mt-2 mb-0 rounded-1 fs-7">
                          <FontAwesomeIcon
                            icon={faUserPlus}
                            className="me-2"
                            size="sm"
                          />
                          Users
                        </h6>
                        <div
                          className={`button-wrapper ${
                            activeTab === "#roles" ? "active-tab" : ""
                          }`}
                        >
                          <div className="indicator" />
                          <Button
                            variant={
                              activeTab === "#roles"
                                ? "outline-success"
                                : "primary"
                            }
                            className="w-100 text-start border-0 fs-7"
                            onClick={() => handleTabChange("#roles")}
                          >
                            Create Roles
                          </Button>
                        </div>
                        <div
                          className={`button-wrapper ${
                            activeTab === "#adduser" ? "active-tab" : ""
                          }`}
                        >
                          <div className="indicator" />
                          <Button
                            variant={
                              activeTab === "#adduser"
                                ? "outline-success"
                                : "primary"
                            }
                            className="w-100 text-start border-0 fs-7"
                            onClick={() => handleTabChange("#adduser")}
                          >
                            Add User
                          </Button>
                        </div>
                      </>
                    )}
                    <h6 className="text-white bg-primary-dark fw-normal p-2 mt-2 mb-0 rounded-1 fs-7">
                      <FontAwesomeIcon
                        icon={faClipboard}
                        className="me-2"
                        size="sm"
                      />
                      Other
                    </h6>
                    {permissions.viewTransactions && (
                      <div
                        className={`button-wrapper ${
                          activeTab === "#reports" ? "active-tab" : ""
                        }`}
                      >
                        <div className="indicator" />
                        <Button
                          variant={
                            activeTab === "#reports"
                              ? "outline-success"
                              : "primary"
                          }
                          className="w-100 text-start border-0 fs-7"
                          onClick={() => handleTabChange("#reports")}
                        >
                          Transactions
                        </Button>
                      </div>
                    )}
                    <div
                      className={`button-wrapper ${
                        activeTab === "#documents" ? "active-tab" : ""
                      }`}
                    >
                      <div className="indicator" />
                      <Button
                        variant={
                          activeTab === "#documents"
                            ? "outline-success"
                            : "primary"
                        }
                        className="w-100 text-start border-0 fs-7"
                        onClick={() => handleTabChange("#documents")}
                      >
                        Downloads
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col xs={collapsed ? 11 : 10} className="mx-auto">
              <Tab.Content mountOnEnter>
                {activeTab === "#attendants" && (
                  <Tab.Pane eventKey="#attendants">
                    <Attendants
                      toAddMaid={permissions.toAddMaid}
                      toDeleteMaid={permissions.toDeleteMaid}
                      toDownload={permissions.toDownload}
                      isAdmin={permissions.isAdmin}
                      poolTipEnabled={services.maids?.poolTipEnabled}
                    />
                  </Tab.Pane>
                )}
                {activeTab === "#valet" && (
                  <Tab.Pane eventKey="#valet">
                    <Valets
                      toAddMaid={permissions.toAddMaid}
                      toDeleteMaid={permissions.toDeleteMaid}
                      toDownload={permissions.toDownload}
                      isAdmin={permissions.isAdmin}
                      canRead={permissions.canRead}
                      poolTipEnabled={services.valets?.poolTipEnabled}
                    />
                  </Tab.Pane>
                )}
                {activeTab === "#bellman" && (
                  <Tab.Pane eventKey="#bellman">
                    <Bellman
                      toAddMaid={permissions.toAddMaid}
                      toDeleteMaid={permissions.toDeleteMaid}
                      toDownload={permissions.toDownload}
                      isAdmin={permissions.isAdmin}
                      poolTipEnabled={services.bellmen?.poolTipEnabled}
                    />
                  </Tab.Pane>
                )}
                {activeTab === "#airbnb" && (
                  <Tab.Pane eventKey="#airbnb">
                    <Airbnb
                      toAddMaid={permissions.toAddMaid}
                      toDeleteMaid={permissions.toDeleteMaid}
                      toDownload={permissions.toDownload}
                      isAdmin={permissions.isAdmin}
                      poolTipEnabled={services.airbnb?.poolTipEnabled}
                    />
                  </Tab.Pane>
                )}
                {activeTab === "#profile" && (
                  <Tab.Pane eventKey="#profile">
                    <ClientProfilePage />
                  </Tab.Pane>
                )}
                {activeTab === "#roles" && (
                  <Tab.Pane eventKey="#roles">
                    <AddRoles />
                  </Tab.Pane>
                )}
                {activeTab === "#adduser" && (
                  <Tab.Pane eventKey="#adduser">
                    <AddUser />
                  </Tab.Pane>
                )}
                {activeTab === "#reports" && (
                  <Tab.Pane eventKey="#reports">
                    <ClientReports />
                  </Tab.Pane>
                )}
                {activeTab === "#stats" && (
                  <Tab.Pane eventKey="#stats">
                    <ClientStats />
                  </Tab.Pane>
                )}
                {activeTab === "#documents" && (
                  <Tab.Pane eventKey="#documents">
                    <Documents />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      )}
    </>
  );
};

export default Dashboard;
